import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { ICommonPopupsProps } from '@gem/popups';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';

export interface IChatAutoCleanupSettingsPopupProps
  extends ICommonPopupsProps<{ groupId: string }> {}

interface IChatAutoCleanupSettingsPopupPresenter {
  currentTtlPeriodMs: number;
  groupId: string;
  isSubmitting: boolean;
  group: Group | null;
  isDisabled: boolean;
  setGroupId(groupId: string): void;
  setCurrentTtlPeriodMs(ttlPeriodMs: number): void;
  onClose(): void;
  onSubmit(): void;
}

export function useChatAutoCleanupSettingsPopupPresenter(
  params: IChatAutoCleanupSettingsPopupProps
): IChatAutoCleanupSettingsPopupPresenter {
  const { onClose, popupInstance } = params;
  const groupId = params.params!.groupId;

  const presenter = useLocalObservable<IChatAutoCleanupSettingsPopupPresenter>(() => ({
    groupId,

    isSubmitting: false,

    currentTtlPeriodMs: 0,

    get group(): Group | null {
      return Entities.GroupsStore.getGroupById(presenter.groupId);
    },

    get isDisabled(): boolean {
      return presenter.currentTtlPeriodMs === presenter.group?.ttlPeriodMs;
    },

    setCurrentTtlPeriodMs(ttlPeriodMs: number): void {
      presenter.currentTtlPeriodMs = ttlPeriodMs;
    },

    setGroupId(groupId: string): void {
      presenter.groupId = groupId;
    },

    onClose(): void {
      popupInstance.close();
      onClose?.();
    },

    async onSubmit(): Promise<void> {
      presenter.isSubmitting = true;

      await Tasks.group.setChatMessagesHistoryTtl({
        groupId,
        ttlPeriodMs: presenter.currentTtlPeriodMs,
      });

      presenter.isSubmitting = false;

      presenter.onClose();
      return;
    },
  }));

  useEffect(() => {
    presenter.setGroupId(groupId);
  }, [groupId]);

  useEffect(() => {
    if (!presenter.group) {
      return;
    }
    presenter.setCurrentTtlPeriodMs(presenter.group.ttlPeriodMs);
  }, [presenter.group]);
  return presenter;
}
